<template>
  <div>
    <div v-masonry gutter="15" transition-duration="0s" item-selector=".item">
      <div v-bind:key="index" v-masonry-tile class="mt-1 mb-1 item top-posts"
           v-for="(tweet, index) in filterTopTweets">
        <tweet :id="tweet._id" error-message="." error-message-class="tweet-not-found"></tweet>
        <router-link v-if="tweet.topic1" target='_blank'
                     :to="'/visualizations/topic-modeling?collection=' + collection + '&topic=' + tweet.topic1">
          <badge class="m-2" tag="a" type="info">Topic {{ tweet.topic1 }}</badge>
        </router-link>
        <router-link v-if="tweet.topic2" target='_blank'
                     :to="'/visualizations/topic-modeling?collection=' + collection + '&topic=' + tweet.topic2">
          <badge class="m-2" tag="a" type="info">Topic {{ tweet.topic2 }}</badge>
        </router-link>
        <router-link v-if="tweet.topic3" target='_blank'
                     :to="'/visualizations/topic-modeling?collection=' + collection + '&topic=' + tweet.topic3">
          <badge class="m-2" tag="a" type="info">Topic {{ tweet.topic3 }}</badge>
        </router-link>

        <!--<badge class="m-2" tag="a" href="#" type="info">Topic {{ tweet.topic2 }}</badge>-->
        <!--<badge class="m-2" tag="a" href="#" type="info">Topic {{ tweet.topic3 }}</badge>-->
      </div>
    </div>
    <div class="d-flex justify-content-center" v-if="maxIndex < tweets.length">
      <base-button tag="a"
                   class="mb-3 w-25 mb-sm-0 bg-ptwist text-white"
                   type="button"
                   @click="loadMore">
        Load more
      </base-button>
    </div>
  </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'
import { Tweet } from 'vue-tweet-embed'

export default {
  name: 'top-tweets-masonry',
  directives: {
    imagesLoaded
  },
  props: {
    tweets: {
      type: Array,
      description: 'Tweets for the masonry grid'
    },
    collection: {
      type: String,
      required: true
    }
  },
  computed: {
    filterTopTweets () {
      return this.tweets.filter((tweet, index) => index < this.maxIndex)
    }
  },
  components: { 'tweet': Tweet },
  filters: {
    toString (tweetId) {
      return String(tweetId)
    }
  },
  created () {
    setInterval(() => this.$redrawVueMasonry(), 1)
  },
  methods: {
    loadMore () {
      if (this.maxIndex < 100) {
        this.maxIndex += 9
      }
    }
  },
  data () {
    return {
      maxIndex: 9
    }
  }
}
</script>
<style lang="sass">
  $screen-sm-min: 0px
  @mixin sm
    @media (min-width: #{$screen-sm-min})
      @content
  $screen-lg-min: 992px
  @mixin lg
    @media (min-width: #{$screen-lg-min})
      @content

  .top-posts
    .twitter-tweet
      @include sm
        max-width: 300px !important
      @include lg
        max-width: 21.5rem !important

    .tweet-not-found
      font-size: 0.1px

</style>
